import { render, staticRenderFns } from "./LocationWidget.vue?vue&type=template&id=1d45151b"
import script from "./LocationWidget.vue?vue&type=script&lang=js"
export * from "./LocationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports